<script>
  export let resistance = 0.3;
  export let distance = 120;
  export let rotation = 300;
  export let disabled = false;
  export let onRefresh = () => {};

  let startY = 0;
  let currentY = 0;
  let pulling = false;
  let rotateDeg = 0;
  let shouldRefresh = false;
  let translateY = 0;

  const touchStart = (event) => {
    startY = event.touches[0].clientY;
  };

  const touchMove = (event) => {
    currentY = event.touches[0].clientY;

    if (!disabled && currentY - startY > distance) {
      pulling = true;
      rotateDeg = (currentY - startY) * 1;
      translateY = (currentY - startY) * resistance;

      if (rotateDeg > rotation) {
        shouldRefresh = true;
      } else {
        shouldRefresh = false;
      }
    } else {
      pulling = false;
    }
  };

  const touchEnd = () => {
    if (shouldRefresh) {
      rotateDeg = 0;
      refresh();

      translateY = 60;
    } else {
      translateY = 0;
      pulling = false;
      shouldRefresh = false;
    }
  };

  const refresh = async () => {
    await onRefresh();

    setTimeout(() => {
      translateY = 0;
      pulling = false;
      shouldRefresh = false;
    }, 2000);

    window.location.reload();
  };
</script>

<div on:touchstart={touchStart} on:touchmove={touchMove} on:touchend={touchEnd} class="refresher">
  {#if pulling}
    <div class="indicator">
      {#if shouldRefresh}
        <div class="icon" style="animation-play-state: running;" />
      {:else}
        <div class="icon" style="transform: rotate({rotateDeg}deg); animation-play-state: paused;" />
      {/if}
    </div>
  {/if}

  <div class="content-wrapper" style="transform: translateY({translateY}px)">
    <slot />
  </div>
</div>

<style lang="scss" src="./refresher.scss"></style>
